import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Walks the activated route snapshot tree down to its deepest child — the leaf
 * route that actually matched the current URL (including lazy-loaded children).
 */
export function deepestRouteSnapshot(root: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let node = root;
  while (node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * The global footer is hidden when the deepest activated route declares
 * `data: { hideFooter: true }` — the full-screen workspaces (attendance panel,
 * CRM Kanban board, attendance monitor). See DEV-1927.
 */
export function shouldHideFooter(root: ActivatedRouteSnapshot): boolean {
  return !!deepestRouteSnapshot(root).data?.['hideFooter'];
}
